import { Shirt } from "lucide-react";
import PinterestEmbed from "@/components/PinterestEmbed";
import { withBigEmojis } from "@/lib/emoji";
import { resolveImageUrl } from "@/components/ImageUpload";

export default function Dresscode({ dresscode }) {
  const d = dresscode || {};
  const colors = Array.isArray(d.colors) ? d.colors.filter(Boolean) : [];
  const hasPinterest = !!d.pinterest_board_url;
  if (!d.style && !d.note && colors.length === 0 && !hasPinterest) return null;

  return (
    <section className="py-14 md:py-20 px-6 md:px-10">
      <div className="text-center">
        <p className="overline">Dress code</p>
        {d.sticker_url && (
          <img src={resolveImageUrl(d.sticker_url)} alt="" className="h-56 w-auto max-w-[80%] object-contain mx-auto mt-4 drop-shadow-md" data-testid="dress-sticker" />
        )}
        <h3
          className="text-ink mt-3 font-medium leading-tight"
          style={{ fontSize: "calc(2.25rem * var(--fn-body-scale, 1))" }}
          data-testid="dress-style"
        >
          {d.style || "Con estilo"}
        </h3>
        {d.note && <p className="text-inksoft text-base mt-4 max-w-md mx-auto leading-relaxed whitespace-pre-line" data-testid="dress-note">{withBigEmojis(d.note)}</p>}

        {colors.length > 0 && (
          <div className="mt-8 flex items-center justify-center gap-3 md:gap-4 flex-wrap">
            {colors.map((c, i) => (
              <div
                key={`${c}-${i}`}
                className="w-14 h-14 md:w-16 md:h-16 rounded-full border-2 border-white shadow-md hover:scale-110 transition-transform duration-300"
                style={{ backgroundColor: c }}
                aria-label={c}
                title={c}
              />
            ))}
          </div>
        )}

        <div className="mt-8 inline-flex items-center gap-2 text-warmgold">
          <Shirt size={16} />
          <span className="script text-xl">Nos vemos <span className="emoji-2x">✨</span></span>
        </div>

        {hasPinterest && (
          <div className="mt-10 max-w-md mx-auto">
            <p className="overline mb-4">Inspiración</p>
            <PinterestEmbed boardUrl={d.pinterest_board_url} />
          </div>
        )}
      </div>
    </section>
  );
}
